/**
 * Florastory 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

/**
 * Florastory 品牌特定主题配置
 */
export const theme = {
  popupTagBgColor: '#EFF3FA',
  popupTagColor: '#65686F',
  popupTagActiveColor: '#FFFFFF',

  filterBgColor: '#EFF3FA',
  filterActiveBgColor: '#D4F0E0',
  filterColor: '#65686F',
  filterActiveColor: '#21A967',
} as const

export const tagsConfig: TagsPageConfig = {
  theme,
  texts: tagsCommonConfig.texts,
}
